// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__2RL_f","custom":"Tooltip_custom__21OG0"};